(() => {
  class Prescriber {
    constructor(Auth, Users, $scope) {
      'ngInject';

      $scope.$on('update-prescriber-pause', (event, publisherQualityStats) => {
        if (publisherQualityStats) {
          this.status = this.name + "- paused";
        } else {
          this.status = this.name + "";
        }
      });
      this.name = `${Auth.profile.firstname} ${Auth.profile.lastname}`;
      Users.getVideoStatus().then(data => {
        if (!data.data.paused || data.data.paused === 'undefined') {
          this.status = this.name + "";
        } else {
          this.status = this.name + "- paused";
        }
      }).catch(err => {
        console.log("Users.getVideoStatus error: ", err.statusText); // this.toastr.error(err);
      });
      this.tooltipHtml = `
        <span class="block">Phone: 415 926 5818</span>
        <span class="block">Address: 928 Harrison Street, Suite 200, San Francisco, CA 94107</span>
      `;
    }

  }

  Prescriber.$inject = ["Auth", "Users", "$scope"];
  angular.module('pims').component('prescriber', {
    controller: Prescriber,
    template: `
      <div class="prescriber" uib-tooltip-html="$ctrl.tooltipHtml" tooltip-placement="{{$ctrl.tooltipPlacement || 'left'}}">
        <h6 class="m-0 color-gray-md caps">Prescriber</h6>
        <h5 class="m-0 color-primary show-prescriber-status" ng-bind="$ctrl.status">Lemonaid Health</h5>
      </div>
    `,
    bindings: {
      tooltipPlacement: '<'
    }
  });
})();